import api from 'base/utils/api';
import { IGetListParams, IListPage } from 'mod/product-list/interface';
import { filterProductsFields } from 'base/utils/product';

/**
 * 获取分页商品列表
 */
export function getListPage(data: IGetListParams): Promise<IListPage> {
    return api.post('/web/list', { data }).then(res => {
        res.list = filterProductsFields(res.list);
        return res;
    });
}

/**
 * 根据variantIds 获取variants 列表
 */
export function getVariantsByIds(params:{
    variantIds: string[]
}): Promise<any> {
    return api.post('/web/v2/list/variants', {
        data: params
    })
}